import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'ConflictOfInterests',
  path: 'onboarding.forms.CorporateAccount.ConflictOfInterestsForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'haveAffiliationWithSucden',
            removeLabelEllipsis: true,
            dataList: [
              {
                id: 'haveAffiliationWithSucden1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'haveAffiliationWithSucden2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'affiliationInformation',
            isTextarea: true,
            paddingLeft: '4%',
            removeLabelEllipsis: true,
            required: true,
            textAreaHeight: '90px',
            textAreaPointerEvents: 'auto'
          },
        },
      ],
    },
  ],
})

export default config
